<template>
 <div @click="$emit('openMenu')" class="burger-menu">
   <div class="burger-menu-rectangle"></div>
   <div class="burger-menu-rectangle"></div>
   <div class="burger-menu-rectangle"></div>


 </div>
</template>

<script>
 export default {
  name: 'BurgerMenu',

 }
</script>

<style lang="scss">
@import "BurgerMenu.scss";
</style>
